import { type RefObject, useEffect, useState } from 'react';

const useOnScreen = (
  ref: RefObject<HTMLElement | null>
): { isVisible: boolean; isInMiddle: boolean } => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [isInMiddle, setIsInMiddle] = useState<boolean>(false);

  const isElementVisible = (element: Element | null): boolean => {
    if (!element) return false;

    const { top, bottom } = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    return top < windowHeight && bottom >= 0;
  };

  const isElementInMiddle = (element: Element | null): boolean => {
    if (!element) return false;

    const rect = element.getBoundingClientRect();
    const elementMiddleY = (rect.top + rect.bottom) / 2;
    const windowMiddleY = window.innerHeight / 2;

    return (
      Math.abs(elementMiddleY - windowMiddleY) <
      Math.min(rect.height, window.innerHeight) / 2
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(isElementVisible(ref.current));
      setIsInMiddle(isElementInMiddle(ref.current));
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [ref]);

  return {
    isVisible,
    isInMiddle
  };
};

export default useOnScreen;
